<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Ajukan"
      back-button-text="Kembali"
      next-button-text="Lanjut"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- accoint details tab -->
      <tab-content
        title="Data Mahasiswa"
        :before-change="validationForm"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Data Mahasiswa
              </h5>
              <small class="text-muted">
                Lengkapi data mahasiswa.
              </small>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="nama"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="nama"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="userData.nama"
                    :state="errors.length > 0 ? false:null"
                    placeholder="johndoe"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Email"
                label-for="email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="userData.email"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john.doe@email.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
           <b-col md="6">
              <b-form-group
                label="Angkatan"
                label-for="angkatan"
              >
                <validation-provider
                  #default="{ errors }"
                  name="angkatan"
                  rules="required"
                >
                  <b-form-input
                    id="angkatan"
                    v-model="userData.angkatan"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Angkatan"
                    :type="'number'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="NPM"
                label-for="npm"
              >
                <validation-provider
                  #default="{ errors }"
                  name="npm"
                  rules="required"
                >
                  <b-form-input
                    id="npm"
                    v-model="userData.npm"
                    :state="errors.length > 0 ? false:null"
                    placeholder="NPM"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Prodi"
                label-for="prodi"
              >
                <validation-provider
                  #default="{ errors }"
                  name="prodi"
                  rules="required"
                >
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="prodiOption.options"
                    v-model="userData.prodi_id"
                    placeholder="Pilih prodi"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Tempat Lahir"
                label-for="tempat_lahir"
              >
                <validation-provider
                  #default="{ errors }"
                  name="tempat_lahir"
                  rules="required"
                >
                  <b-form-input
                    id="tempat_lahir"
                    v-model="userData.tempat_lahir"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Tempat Lahir"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Tanggal Lahir <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="tanggal_lahir"
                  rules="required"
                >
                  <b-form-datepicker v-model="userData.tanggal_lahir" locale="id"></b-form-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="NIK"
                label-for="nik"
              >
                <validation-provider
                  #default="{ errors }"
                  name="nik"
                  rules="required"
                >
                  <b-form-input
                    id="nik"
                    v-model="userData.nik"
                    :state="errors.length > 0 ? false:null"
                    placeholder="NIK"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Nomor Telp"
                label-for="nomor_telp"
              >
                <validation-provider
                  #default="{ errors }"
                  name="nomor_telp"
                  rules="required"
                >
                  <b-form-input
                    id="nomor_telp"
                    v-model="userData.nomor_telp"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor Telp"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Nomor HP"
                label-for="nomor_hp"
              >
                <validation-provider
                  #default="{ errors }"
                  name="nomor_hp"
                  rules="required"
                >
                  <b-form-input
                    id="nomor_hp"
                    v-model="userData.nomor_hp"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor HP"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Email Selain UI"
                label-for="email selain ui"
              >
                <validation-provider
                  #default="{ errors }"
                  name="email_selain_ui"
                  rules="required|email"
                >
                  <b-form-input
                    id="email_selain_ui"
                    v-model="userData.email_selain_ui"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john.doe@email.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Nama Lengkap Orang Tua"
                label-for="nama_lengkap_orang_tua"
              >
                <validation-provider
                  #default="{ errors }"
                  name="nama_lengkap_orang_tua"
                  rules="required"
                >
                  <b-form-input
                    id="nama_lengkap_orang_tua"
                    v-model="userData.nama_lengkap_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="johndoe"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Jabatan Orang Tua"
                label-for="jabatan_orang_tua"
              >
                <validation-provider
                  #default="{ errors }"
                  name="jabatan_orang_tua"
                  rules="required"
                >
                  <b-form-input
                    id="jabatan_orang_tua"
                    v-model="userData.jabatan_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Jabatan orang tua"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Instansi Kerja Orang Tua"
                label-for="instansi_kerja_orang_tua"
              >
                <validation-provider
                  #default="{ errors }"
                  name="instansi_kerja_orang_tua"
                  rules="required"
                >
                  <b-form-input
                    id="instansi_kerja_orang_tua"
                    v-model="userData.instansi_kerja_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Instansi kerja orang tua"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Total SKS Diperoleh"
                label-for="jumlah_sks_diperoleh"
              >
                <validation-provider
                  #default="{ errors }"
                  name="jumlah_sks_diperoleh"
                  rules="required"
                >
                  <b-form-input
                    id="jumlah_sks_diperoleh"
                    v-model="berkas.jumlah_sks_diperoleh"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Jumlah SKS Diperoleh"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Apakah Anda pernah mengulang Mata Kuliah selama berkuliah di FPsi UI dan di UQ?"
                label-for="mengulang_mata_kuliah"
              >
                <validation-provider
                  #default="{ errors }"
                  name="mengulang_mata_kuliah"
                  rules="required"
                >
                <v-select
                    id="mengulang_mata_kuliah"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="konfirmasiOption.options"
                    v-model="berkas.mengulang_mata_kuliah"
                    placeholder="Pilih Jawaban"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="berkas.mengulang_mata_kuliah == 'ya'">
              <b-form-group
                label="Apabila pernah mengulang Mata Kuliah, mohon tuliskan seluruh nama Mata
Kuliah yang harus diulang."
                label-for="mata_kuliah_diulang"
              >
                <validation-provider
                  #default="{ errors }"
                  name="mata_kuliah_diulang"
                  rules="required"
                >
                <b-form-textarea
                  :state="errors.length > 0 ? false:null"
                  id="alamat"
                  v-model="berkas.mata_kuliah_diulang"
                  placeholder="Mata kuliah yang diulang"
                  rows="5"
                ></b-form-textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Apakah Anda pernah mengajukan cuti akademik selama masa kuliah?"
                label-for="pernah_cuti"
              >
                <validation-provider
                  #default="{ errors }"
                  name="pernah_cuti"
                  rules="required"
                >
                <v-select
                    id="pernah_cuti"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="konfirmasiOption.options"
                    v-model="berkas.pernah_cuti"
                    placeholder="Pilih Jawaban"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="berkas.pernah_cuti == 'ya'">
              <b-form-group
                label="Apabila pernah mengajukan cuti akademik, mohon tuliskan total jumlah
semester Anda berstatus cuti"
                label-for="total_cuti"
              >
                <validation-provider
                  #default="{ errors }"
                  name="total_cuti"
                  rules="required"
                >
                <b-form-input
                    id="total_cuti"
                    v-model="berkas.total_cuti"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Jumlah Cuti"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12" class="mt-2">
              <b-form-group
                label=""
                label-for="judul_final_indonesia"
              >
                <validation-provider
                  #default="{ errors }"
                  name="judul_final_indonesia"
                  rules="required"
                >
                <p style="text-align: justify;">Judul Tugas Akhir UI-ANA dalam Bahasa Indonesia (Tuliskan judul Tugas Akhir UI-ANA dalam Bahasa Indonesia yang sudah final dan dimasukkan
di SIAK NG. Judul Tugas Akhir harus dimasukkan terlebih dahulu ke SIAK NG melalui pilihan
Skripsi di menu Mata Kuliah Spesial dengan mengetikkan judul ke kolom yang sesuai, dan
bukan dengan melakukan copy-paste judul dari naskah. Judul yang di copy-paste berisiko
mengalami perubahan tampilan pada SIAK NG. Jika judul Tugas Akhir di SIAK NG masih
kosong, maka pendaftaran Yudisium tidak akan diproses.
Pastikan bahwa penulisan judul Bahasa Indonesia sudah dikonsultasikan dengan
Pembimbing UI-ANA dan sesuai dengan kaidah PUEBI, seperti yang dapat dilihat di tautantautan berikut: <br><br>
<a href="https://badanbahasa.kemdikbud.go.id/lamanbahasa/sites/default/files/PUEBI.pdf">
  https://badanbahasa.kemdikbud.go.id/lamanbahasa/sites/default/files/PUEBI.pdf
</a>
 <br>
 <a href="https://blog.typoonline.com/cara-penulisan-judul-yang-benar/">
  https://blog.typoonline.com/cara-penulisan-judul-yang-benar/
</a>
</p>
                <b-form-textarea
                  :state="errors.length > 0 ? false:null"
                  id="judul_final_indonesia"
                  v-model="berkas.judul_final_indonesia"
                  placeholder="Judul Final Indonesia"
                  rows="5"
                ></b-form-textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label=""
                label-for="judul_final_inggris"
              >
                <validation-provider
                  #default="{ errors }"
                  name="judul_final_inggris"
                  rules="required"
                >
                <p style="text-align:justify;">Judul Tugas Akhir UI-ANA dalam Bahasa Inggris (Tuliskan judul Tugas Akhir UI-ANA dalam Bahasa Inggris yang sudah final dan dimasukkan di
SIAK NG. Judul Tugas Akhir harus dimasukkan terlebih dahulu ke SIAK NG melalui pilihan
Skripsi di menu Mata Kuliah Spesial dengan mengetikkan judul ke kolom yang sesuai, dan
bukan dengan melakukan copy-paste judul dari naskah. Judul yang di copy-paste berisiko
mengalami perubahan tampilan pada SIAK NG. Jika judul Tugas Akhir di SIAK NG masih
kosong, maka pendaftaran Yudisium tidak akan diproses.
Pastikan bahwa penulisan judul Bahasa Inggris sudah dikonsultasikan dengan Pembimbing
UI-ANA dan sesuai dengan kaidah penulisan Bahasa Inggris, seperti yang dapat dilihat di
tautan-tautan berikut: <br><br>
<a href="https://apastyle.apa.org/style-grammar-guidelines/capitalization/title-case">
  https://apastyle.apa.org/style-grammar-guidelines/capitalization/title-case
</a>
 <br>
 <a href="https://www.grammarly.com/blog/capitalization-in-the-titles/">
  https://www.grammarly.com/blog/capitalization-in-the-titles/
</a>
 <br>
 <a href="https://www.gramediaacademy.com/blog/read/cara-penulisan-judul-yang-tepat-dalambahasa-inggris/29">
  https://www.gramediaacademy.com/blog/read/cara-penulisan-judul-yang-tepat-dalambahasa-inggris/29
</a>
</p>
                <b-form-textarea
                  :state="errors.length > 0 ? false:null"
                  id="judul_final_inggris"
                  v-model="berkas.judul_final_inggris"
                  placeholder="Judul Final Inggris"
                  rows="5"
                ></b-form-textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Pembimbing Tugas Akhir UI-ANA"
                label-for="dosen_pembimbing"
              >
                <validation-provider
                  #default="{ errors }"
                  name="dosen_pembimbing"
                  rules="required"
                >
                  <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="berkas.dosen_pembimbing_id"
                    placeholder="Pilih Dosen Pembimbing"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- personal details tab -->
      <tab-content
        title="Berkas Yudisium"
        :before-change="validationFormInfo"
      >
        <validation-observer
          ref="infoRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Berkas Yudisium
              </h5>
              <small class="text-muted">Berkas Yudisium Anda</small>
            </b-col>
          </b-row>
          <!-- Berkas Yudisium -->
          <b-row v-for="item in userData.berkas_yudisium" :key="item.uuid" style="margin-bottom: 10px;">
            <b-col md="6">
              <b-form-group>
                <label for="">{{ item.title }} <span style="color: red; font-size: 16px;" v-if="item.is_required">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  :name="item.title"
                  :rules="item.is_required == 1 && item.file == null ? 'required' : ''"
                >
                <div class="d-flex">
                   <b-form-file
                    ref="file-input"
                    v-model="item.file_input"
                    accept="application/pdf"
                  />
                  <b-button
                    v-if="item.file != null"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="mb-75 mr-75 ml-1"
                    @click="lihatFile(item.file)"
                  >
                    Lihat
                  </b-button>
                  <div>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      :variant="$can('set-note-berkas', 'pengajuan-sidang') ? 'outline-primary' : 'danger'"
                      class="mb-75 mr-75 ml-1"
                      @click="$bvModal.show(`bv-modal-note${item.berkas_pengajuan_uuid}`)"
                      v-if="item.note != null"
                    >
                      Catatan
                    </b-button>
                    <b-modal :id="`bv-modal-note${item.berkas_pengajuan_uuid}`" hide-footer>
                      <template #modal-title>
                        Catatan Perbaikan Berkas
                      </template>
                      <div class="d-block text-center">
                        <b-form-textarea rows="5" placeholder="Catatan Perbaikan" v-model="item.note"></b-form-textarea>
                      </div>
                      <center>
                        <b-button class="mt-3" variant="danger" @click="$bvModal.hide(`bv-modal-note${item.berkas_pengajuan_uuid}`)">Tutup</b-button>
                      </center>>
                    </b-modal>
                  </div>
                </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
             <b-col md="6">
               <label for="">{{ item.description }}</label>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- address  -->
      <tab-content
        title="Konfirmasi"
        :before-change="validationFormAddress"
      >
        <validation-observer
          ref="addressRules"
          tag="form"
        >
          <b-row style="text-align: center;">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Konfirmasi untuk mengajukan berkas yudisium?
              </h5>
              <h5 class="mb-0">
                Pastikan dan cek kembali data anda sebelum mengajukan berkas yudisium.
              </h5>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      <!-- Modal Loading -->
      <div>
        <b-modal id="modal-center-loading" centered title="Loading" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close v-if="showModal === 1">
          <div class="d-flex justify-content-center mt-2">
            <b-spinner
            :variant="'dark'"
            ></b-spinner>
          </div>
          <div class="d-flex justify-content-center mt-2">
           Loading....
          </div>
          <b-button class="mt-3" block @click="reload()" variant="primary">Muat Ulang</b-button>
        </b-modal>
      </div>
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BCalendar,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
  BModal,
  BSpinner,
  BFormTextarea,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { codeIcon } from './code'
import {
  getPengajuanYudisium,
  updateDataMahasiswa,
  updateBerkasYudisium,
  uploadFilePengajuan,
  downloadDokumen,
  updateStatusYudisium,
} from '@/connection-api/master'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    BButton,
    BCalendar,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BModal,
    BSpinner,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  data() {
      // 15th two months prior
      const minDate = new Date('2023-06-12')
      minDate.setDate(minDate.getDate())
      // 15th in two months
      const maxDate = new Date('2023-07-12')
      maxDate.setDate(maxDate.getDate())

    return {
      showModal: 1,
      file: null,
      minTime: '08:00',
      maxTime: '16:00',
      min: minDate,
      max: maxDate,
      selectedContry: '',
      selectedLanguage: '',
      userData: {},
      berkas: {},
      required,
      email,
      codeIcon,
      countryName: [
        { value: 'select_value', text: 'Select Value' },
        { value: 'Russia', text: 'Russia' },
        { value: 'Canada', text: 'Canada' },
        { value: 'China', text: 'China' },
        { value: 'United States', text: 'United States' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Australia', text: 'Australia' },
        { value: 'India', text: 'India' },
      ],
      languageName: [
        { value: 'nothing_selected', text: 'Nothing Selected' },
        { value: 'English', text: 'English' },
        { value: 'Chinese', text: 'Mandarin Chinese' },
        { value: 'Hindi', text: 'Hindi' },
        { value: 'Spanish', text: 'Spanish' },
        { value: 'Arabic', text: 'Arabic' },
        { value: 'Malay', text: 'Malay' },
        { value: 'Russian', text: 'Russian' },
      ],
      konfirmasiOption: {
        selected: 'id',
        options: [
          { value: null, title: 'Pilih' },
          { value: 'ya', title: 'Ya' },
          { value: 'tidak', title: 'Tidak' },
        ],
      },
      jurusanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jurusan --' },
        ],
      },
      jenjangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenjang --' },
        ],
      },
      peminatanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Peminatan --' },
        ],
      },
      prodiOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Prodi --' },
        ],
      },
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenis Sidang --' },
        ],
      },
      prosesPersidanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Proses Persidangan --' },
        ],
      },
      dosenOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Dosen --' },
        ],
      },
    }
  },
  mounted() {
      this.$bvModal.show('modal-center-loading')
      var success_check = []
      var error_check = []
          getPengajuanYudisium(this.$route.params.uuid)
          .then(response => {
            if (response.data.success == true) {
              this.userData = response.data.data
              this.berkas = this.userData.ujian

              if(this.userData.prodi.length > 0)
              {
                this.buildOption(this.userData.prodi, this.prodiOption)
              }
              if(this.userData.dosen.length > 0)
              {
                this.buildOption(this.userData.dosen, this.dosenOption)
              }
              this.$bvModal.hide('modal-center-loading')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengajuan Yudisium',
                  icon: 'EditIcon',
                  variant: 'success',
                  text: 'Berhasil mendapatkan data',
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengajuan Yudisium',
                  icon: 'EditIcon',
                  variant: 'danger',
                  text: response.data.message,
                },
                duration: 5000,
              })
            }
          })
          .catch(error => console.log(error));
  },
  methods: {
    async lihatFile(file) {
      try {
        if (typeof file === 'object') {
          // kode yang dijalankan jika file adalah object
          file = file.nama
        }
        const resp = await downloadDokumen(file);
        var type_file = file.substring(file.length - 4);
        if (type_file === ".pdf") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "application/pdf" })
          );
        }
        if (type_file === ".png" || type_file === ".PNG" || 
            type_file === ".jpg" || type_file === ".JPG" || 
            type_file === ".jpeg" || type_file === ".JPEG") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "image/" + type_file.slice(1) })
          );
        }
        window.open(this.imageFile);
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Pengajuan Sidang',
            icon: 'EditIcon',
            variant: 'danger',
            text: 'File tidak ditemukan',
          },
          duration: 5000,
        })
      }
    },
    buildOption(data, option) {
      data.forEach(element => {
        option.options.push({
          title: element.nama,
          value: element.uuid,
        })
      })
    },
    completeCheck(success_check)
    {
      if(success_check.length == 12)
      {
        this.showModal = 0
      }
    },
    reload()
    {
      window.location.reload()
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay()
      const day = date.getDate()
      // Return `true` if the date should be disabled
      // return weekday === 0 || weekday === 6 || day === 14
        return weekday === 0
    },
    formSubmitted() {
      if(window.confirm('Apakah anda yakin ingin mengajukan berkas yudisium ini?'))
      {
        var data = {
          uuid: this.userData.uuid
        }
        updateStatusYudisium(data)
          .then(response => {
            if (response.data.success == true) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Yudisium',
                  icon: 'EditIcon',
                  variant: 'success',
                  text: 'Data berhasil diajukan',
                },
                duration: 5000,
              })
              this.$router.push({name: 'daftar-yudisium'})
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Yudisium',
                  icon: 'EditIcon',
                  variant: 'danger',
                  text: 'Data gagal diajukan',
                },
              })
            }
          })
          .catch(error => console.log(error));
      }
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            this.userData.flag = "data"
            this.userData.ujian = this.berkas
            updateDataMahasiswa(this.userData)
            .then(response => {
              if (response.data.success == true) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'success',
                    text: 'Data berhasil disimpan',
                  },
                  duration: 5000,
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: 'Data gagal disimpan',
                  },
                })
              }
            })
            .catch(error => console.log(error));
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            this.userData.berkas_yudisium.forEach(function(value, index, data) {
              // Code to execute for each element in the array
              if(data[index].file_input != null)
              {
                uploadFilePengajuan(data[index].file_input, 'user', event => {
                var progress = Math.round((100 * event.loaded) / event.total)
              })
                .then(response0 => {
                  data[index].file = response0.data.data
                  data[index].flag = 'berkas yudisium'
                  updateBerkasYudisium(data[index])
                  .then(response => {
                    if (response.data.success == true) {
                    } else {
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Yudisium',
                          icon: 'EditIcon',
                          variant: 'danger',
                          text: response.data.message,
                        },
                      })
                    }
                  })
                  .catch(error => console.log(error));
                })
              .catch(error => console.log(error));
              }
            });
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>
